<template>
  <!-- 

  [ type a 보더 옵션 / default : 없음 ]
  .border

  [ type a 간격 옵션 / default : 없음 ]
  .spacing--sm
  .spacing--md
  .spacing--lg

  -->

  <header class="">
    <div class="logo-container">
      <logo class="logo--xs"></logo>
    </div>
    <div class="nav-container">
      <div class="menu-main-container">
        <menu-main class="horizontal"></menu-main>
      </div>
      <div class="menu-user-container icon--hidden">
        <menu-user class="horizontal"></menu-user>
      </div>
    </div>
  </header>

</template>

<script>
export default {
  components: {
    Logo: () => import('@/component/common/Logo'),
    MenuMain: () => import('@/component/layout/header/common/MenuMain'),
    MenuUser: () => import('@/component/layout/header/common/MenuUser')
  }
}
</script>
